/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the NewSPMFileUploadContents
 *
 * @class NewSPMFileUploadContents
 */
class NewSPMFileUploadContents {
  /**
   * Creates an instance of NewSPMFileUploadContents.
   * @param {*} json
   * @memberof NewSPMFileUploadContents
   */
  constructor(json = null) {
    if (json) {
      // string
      this.contentType = json.contentType;

      // string
      this.metaData = json.metaData;

      // string
      this.fileName = json.fileName;

      // string
      this.attachmentContent = json.attachmentContent;
    }
  }
}

/**
 * Models the NewSPMFileIDResponse
 *
 * @class NewSPMFileIDResponse
 */
class NewSPMFileIDResponse {
  /**
   * Creates an instance of NewSPMFileIDResponse.
   * @param {*} json
   * @memberof NewSPMFileIDResponse
   */
  constructor(json = null) {
    if (json) {
      // string
      this.fileId = json.fileId;
    }
  }
}

/**
 * Models the SPMFileDownloadContents
 *
 * @class SPMFileDownloadContents
 */
class SPMFileDownloadContents {
  /**
   * Creates an instance of SPMFileDownloadContents.
   * @param {*} json
   * @memberof SPMFileDownloadContents
   */
  constructor(json = null) {
    if (json) {
      // string
      this.data = json.data;

      // string
      this.contentType = json.contentType;

      // string
      this.metaData = json.metaData;

      // string
      this.fileName = json.fileName;
    }
  }
}

export default {
  NewSPMFileUploadContents,

  NewSPMFileIDResponse,

  SPMFileDownloadContents,
};
